module.exports = __webpack_public_path__ + "static/avatar-jeff-bce8d38f7ed032de3e2efdd7e864daac.png";